import SmoothScroll from 'smooth-scroll';

const smoothScroll = new SmoothScroll('a[href^="#"]');
